import React from 'react'
import { faBoxesAlt } from '@fortawesome/pro-regular-svg-icons/faBoxesAlt'
import { isRouteAllowed, reverse } from 'src/routes/config'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'
import useTranslations from 'src/hooks/useTranslations'
import useUserData from 'src/hooks/useUserData'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'

const baseUrlHorizon = getEnvVariableValue(VARIABLES.OLD_HORIZON_BASE_URL)

export default function InventoryMenu({ parentIsCollapsed, isOpen, onClick }) {
    const { t } = useTranslations('MainMenu', 'MainMenu')
    const userData = useUserData()

    return (
        <MainMenuItem
            icon={faBoxesAlt}
            iconActive={faBoxesAlt}
            title={t('Inventory')}
            isOpen={isOpen}
            onClick={onClick}
            parentIsCollapsed={parentIsCollapsed}
        >
            {isRouteAllowed(userData, 'devices') && (
                <MainMenuItem
                    title={t('Devices')}
                    to={
                        isFeatureEnabled(FEATURES.INVENTORY_MENU_OPTION)
                            ? reverse('devices')
                            : {
                                  pathname: `${baseUrlHorizon}/inventory`,
                              }
                    }
                    externalLink={
                        !isFeatureEnabled(FEATURES.INVENTORY_MENU_OPTION)
                    }
                />
            )}
            {isRouteAllowed(userData, 'capacity') && (
                <MainMenuItem
                    title={t('Capacity')}
                    to={
                        isFeatureEnabled(FEATURES.INVENTORY_MENU_OPTION)
                            ? reverse('capacity')
                            : {
                                  pathname: `${baseUrlHorizon}/inventory/capacity`,
                              }
                    }
                    externalLink={
                        !isFeatureEnabled(FEATURES.INVENTORY_MENU_OPTION)
                    }
                />
            )}
            {isRouteAllowed(userData, 'sam') && (
                <MainMenuItem
                    title={t('SAM')}
                    to={
                        isFeatureEnabled(FEATURES.INVENTORY_MENU_OPTION)
                            ? reverse('sam')
                            : {
                                  pathname: `${baseUrlHorizon}/inventory/software-asset-management`,
                              }
                    }
                    externalLink={
                        !isFeatureEnabled(FEATURES.INVENTORY_MENU_OPTION)
                    }
                />
            )}
        </MainMenuItem>
    )
}
